import Cookies from 'js-cookie';
var domain = 'evertransit.com';
export default function removeFirebaseCookieToken() {
  return Cookies.remove('firebaseToken', {
    path: '/',
    domain: domain
  });
}